import _ from 'lodash';
import { useTheme } from 'next-themes';
import { VictoryAxis, VictoryChart, VictoryLine } from 'victory';

const LIGHT_LINE_COLORS = [
  'rgb(4, 79, 137)',
  'rgb(247, 160, 0)',
  'rgb(1, 170, 100)',
];

const DARK_LINE_COLORS = [
  'rgb(0, 160, 224)',
  'rgb(247, 160, 0)',
  'rgb(1, 170, 100)',
];

export function MultiLinePreview({ question }) {
  const entries = question.patientEntries;

  const { theme } = useTheme();

  const LINE_COLORS = theme === 'light' ? LIGHT_LINE_COLORS : DARK_LINE_COLORS;

  const data = entries.map((entry) => {
    return {
      ...entry,
      // Victory requires the date to be a JS date object
      date: new Date(entry.date),
    };
  });

  const areaData = [...data];
  _.remove(areaData, ['skipped', true]);

  const { yMin, yMax } = question;

  return (
    <div className="p-4" style={{ height: '200px' }}>
      <VictoryChart
        data={data}
        x="date"
        scale={{ x: 'time' }}
        minDomain={{ y: yMin }}
        maxDomain={{ y: yMax }}
        height={600}
        width={800}
      >
        <VictoryAxis
          style={{
            ticks: { stroke: 'transparent' },
            tickLabels: { fill: 'transparent' },
          }}
        />
        <VictoryAxis
          dependentAxis
          invertAxis={question.reverseY}
          tickValues={[yMin, yMax]}
          style={{
            ticks: { stroke: 'transparent' },
            tickLabels: { fill: 'transparent' },
          }}
        />
        {question.answers.map((_answer, i) => {
          const color = LINE_COLORS[i];
          return (
            <VictoryLine
              key={i}
              scale="time"
              style={{
                data: {
                  stroke: color,
                  strokeWidth: 4,
                },
              }}
              x="date"
              y={`answer_${i}`}
              data={areaData}
              name="area"
              y0={() => (question.reverseY ? yMax : yMin)}
            />
          );
        })}
      </VictoryChart>
    </div>
  );
}
